module.exports = __webpack_public_path__ + "static/img/icon_alarm_nodata.edb70d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_alarm_nodata.svg
// module id = DzrP
// module chunks = 10